import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

export const Header = (props) => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  return (
    <header id="header" style={{ position: "relative" }}>
      <div className="header-bg">
        {/* <Particles
          id="tsparticles"
          init={particlesInit}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
          options={{
            fullScreen: { enable: false },
            background: { color: { value: "#00569e" } },
            particles: {
              number: { value: 50, density: { enable: true, value_area: 800 } },
              color: { value: "#ffffff" },
              shape: { type: "triangle" },
              opacity: { value: 0.3 },
              size: { value: 3 },
              line_linked: {
                enable: true,
                distance: 250,
                color: "#ffffff",
                opacity: 0.25,
                width: 0.5,
              },
              move: {
                enable: true,
                speed: 2,
                out_mode: "bounce",
              },
            },
            interactivity: {
              events: {
                onhover: { enable: true, mode: "grab" },
                resize: true,
              },
              modes: { grab: { distance: 200, duration: 0.4 } },
            },
            retina_detect: true,
          }}
        /> */}
        {/* <Particles
          id="tsparticles"
          init={particlesInit}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
          options={{
            fullScreen: { enable: false },
            background: {
              color: { value: "#00569e" },
            },
            fpsLimit: 120,
            detectRetina: true,
            interactivity: {
              events: {
                onClick: {
                  enable: false,
                  mode: "push",
                },
                onHover: {
                  enable: true,
                  mode: "grab",
                  parallax: {
                    enable: false,
                    force: 30,
                    smooth: 10,
                  },
                },
                resize: true,
              },
              modes: {
                grab: {
                  distance: 300,
                  links: {
                    opacity: 0.8,
                  },
                },
                push: {
                  quantity: 4,
                },
              },
            },
            particles: {
              number: {
                value: 60,
                density: {
                  enable: true,
                  area: 800,
                },
              },
              color: {
                value: "#fff",
              },
              shape: {
                type: "circle",
              },
              opacity: {
                value: 0.3,
                animation: {
                  enable: true,
                  speed: 1,
                },
              },
              size: {
                value: 3,
                animation: {
                  enable: true,
                  speed: 15,
                  startValue: "random",
                },
              },
              links: {
                enable: true,
                distance: 250,
                color: "#fff",
                opacity: 0.3,
                width: 0.5,
                triangles: {
                  enable: false,
                  frequency: 1,
                },
              },
              move: {
                enable: true,
                speed: 2,
                outModes: {
                  default: "bounce",
                },
              },
            },
            pauseOnBlur: true,
            pauseOnOutsideViewport: true,
          }}
        /> */}
        {/* <img src="img/modern_tech_office.png" alt="header-bg" /> */}
        <div className="header-bg-color" />
      </div>
      <div className="header-bg-color-2" />
      <div className="intro" style={{ position: "relative", zIndex: 1 }}>
        <div className="overlay">
          <div className="container">
            <div className="row display-flex">
              <div className="col-md-12 intro-text">
                <div className="intro-text-first">
                  <div className="intro-text-first-icon" />
                  <span>Precision-Driven Technology Solutions</span>
                </div>
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span>{props.data ? props.data.title2 : "Loading"}</span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <div className="header-btn">
                  <a
                    href="#contact"
                    className="btn btn-contact btn-lg page-scroll"
                    onClick={() => props.handleNavigate && props.handleNavigate("#contact")}
                  >
                    Get Started
                  </a>
                  <a
                    href="#services"
                    className="btn btn-services btn-lg page-scroll"
                    onClick={() => props.handleNavigate && props.handleNavigate("#services")}
                  >
                    Services
                  </a>
                </div>
                <div className="header-value-props">
                  <div className="header-value-props-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-lock-icon w-5 h-5 text-primary"><path d="M4 9.8V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2h-3" /><path d="M14 2v5a1 1 0 0 0 1 1h5" /><path d="M9 17v-2a2 2 0 0 0-4 0v2" /><rect width="8" height="5" x="3" y="17" rx="1" /></svg>
                    <span>NDA Protected</span>
                    <span className="header-value-props-item-separator">•</span>
                  </div>
                  <div className="header-value-props-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zap w-5 h-5 text-primary"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>
                    <span>Fast Delivery</span>
                    <span className="header-value-props-item-separator">•</span>
                  </div>
                  <div className="header-value-props-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up w-5 h-5 text-primary"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>
                    <span>Scalable Solutions</span>
                    <span className="header-value-props-item-separator">•</span>
                  </div>
                  <div className="header-value-props-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users w-5 h-5 text-primary"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    <span>Dedicated Support</span>
                  </div>
                </div>
              </div>
              <div className="mouse-icon">
                <div className="mouse-icon-2">
                  <div className="mouse-icon-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header >
  );
};
